import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { VehicleIcon } from '@moia-dev/pace-icons'
import { VehicleAreaRoutes } from './VehicleAreaRoutes'

export const VehicleAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={VehicleAreaRoutes.Table.route}
      Icon={VehicleIcon}
    />
  )
}
